/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { typedDependencies } from './dependenciesTyped.generated.js';
import { createTanh } from '../../factoriesAny.js';
export var tanhDependencies = {
  typedDependencies,
  createTanh
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/mathjs/lib/esm/entry/dependenciesAny/dependenciesTanh.generated.js
// module id = null
// module chunks = 